/**
 * @file Messages for Feedback component
 */

export const scope = 'app-components-Feedback';

const messages = {
  question: `${scope}-question`,
  great: `${scope}-great`,
  why: `${scope}-why`,
  cannedResponse: {
    positiveOne: `${scope}-cannedResponse-positive-one`,
    positiveTwo: `${scope}-cannedResponse-positive-two`,
    positiveThree: `${scope}-cannedResponse-positive-three`,
    negativeOne: `${scope}-cannedResponse-negative-one`,
    negativeTwo: `${scope}-cannedResponse-negative-two`,
    negativeThree: `${scope}-cannedResponse-negative-three`,
    negativeFour: `${scope}-cannedResponse-negative-four`,
  },
  textbox: `${scope}-textbox`,
  submit: `${scope}-submit`,
  cancel: `${scope}-cancel`,
  validation: `${scope}-validation`,
  thanks: `${scope}-thanks`,
  thanksWithFollowup: `${scope}-thanksWithFollowup`,
  error: `${scope}-error`,
  notice: `${scope}-notice`,
  article: `${scope}-article`,
  helps: `${scope}-helps`,
  guide: `${scope}-guide`,
  page: `${scope}-page`,
};

export default messages;
